import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth } from "../../blocks/layout/columnSpans";

/**
 * Static Marketing List as page config. Created/modified details aren't fields here -
 * EntityPage summarises them in the footer.
 */
export const marketingListPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "list",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 12, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-members",
              title: "Members",
              headerComponentKey: "manageMarketingListMembers",
              fields: [
                {
                  id: "field-members",
                  type: "component",
                  name: "members",
                  label: "",
                  componentKey: "marketingListMembers",
                  // Reads and writes members itself, never through the record's save.
                  excludeFromSave: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 12, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-static-marketing-list",
              // The page bar already names the record.
              title: "",
              fields: [
                {
                  id: "field-listname",
                  type: "text",
                  name: "listname",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  helpText:
                    "Type a name for the static marketing list so that it is identified correctly in lists.",
                  span: fullWidth,
                },
                {
                  id: "field-createdfromcode",
                  type: "picklist",
                  name: "createdfromcode",
                  label: "Targeted At",
                  helpText:
                    "Select the type of members that this static marketing list will contain.",
                  options: [
                    { Key: 1, Value: "Account" },
                    { Key: 2, Value: "Contact" },
                  ],
                  span: fullWidth,
                },
                {
                  id: "field-g4c_sequencenumber",
                  type: "number",
                  name: "g4c_sequencenumber",
                  label: "Sequence",
                  span: fullWidth,
                },
              ],
            },
            {
              kind: "section",
              id: "section-subscriptions",
              title: "Subscriptions",
              fields: [
                {
                  id: "field-g4c_issubscription",
                  type: "boolean",
                  name: "g4c_issubscription",
                  label: "Is Subscription",
                  helpText:
                    "Offer this list as a subscription that contacts can opt in to or out of in their email preferences.",
                  span: fullWidth,
                },
                {
                  id: "field-g4c_subscriptiongroupid",
                  type: "lookup",
                  name: "g4c_subscriptiongroupid",
                  label: "Email Preference Group",
                  helpText:
                    "The group this subscription is shown under in a contact’s email preferences.",
                  lookupEntity: "g4c_subscriptiongroup",
                  manageRoute: "/email-preference-group",
                  // Its menu always opens downward; a native one opens upward near the bottom.
                  searchable: true,
                  span: fullWidth,
                },
                {
                  id: "field-g4c_subscriptiondescription",
                  type: "text",
                  name: "g4c_subscriptiondescription",
                  label: "Email Preference Description",
                  helpText:
                    "The text shown to contacts beside this subscription in their email preferences.",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
